import { render, staticRenderFns } from "./DashboardComponent.vue?vue&type=template&id=51992373&scoped=true"
import script from "./DashboardComponent.vue?vue&type=script&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&lang=js"
import style0 from "./DashboardComponent.vue?vue&type=style&index=0&id=51992373&prod&scoped=true&lang=css"
import style1 from "./DashboardComponent.vue?vue&type=style&index=1&id=51992373&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51992373",
  null
  
)

export default component.exports